export default {"src":"/_next/static/media/san_antonio.21b942c7.svg","height":83,"width":84,"blurWidth":0,"blurHeight":0};